import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { catchError, finalize, map } from "rxjs/operators";
import { Competence } from "../domain/competence";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class MasterCompetenceService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/mastercompetence`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getMasterCompetenceList() {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/active`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMasterCompetenceList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Competence[]) => {
                return response.map((item: Competence) => {
                    return Competence.mapFromJSON(item);
                });
            }));
    }
}